import { auth } from 'fb';
import { onAuthStateChanged } from 'firebase/auth';
import { useEffect, useMemo } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';

const descriptions: { [key: string]: string[] } = {
    artist: [
        "Sign up",
        "Upload your portfolio of 5 artworks",
    ],

    gallery: [
        "Sign up",
        "Upload Gallery profile",
        "Upload portfolio of 3 artists"
    ],
};

export default function RegisterLayout() {
    const localtion = useLocation();
    const navigate = useNavigate();

    const description: string[] = useMemo(() => {
        if (localtion.pathname === '/register/gallery') {
            return descriptions.gallery;
        }
        return descriptions.artist;
    }, [localtion.pathname]);

    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, user => {
            if (user) {
                // Navigate to home page
                navigate('/');
            }
        });

        // Cleanup subscription on unmount
        return () => unsubscribe();
    }, [navigate]);

    return (
        <center className='h-full flex flex-col md:justify-center items-center'>
            <div className='px-6 py-10 w-full xl:max-w-screen-lg flex justify-center md:px-10 md:border md:rounded-lg md:h-4/5' style={{ maxHeight: 1000 }}>
                <div className="hidden flex-1 w-full md:flex md:h-full md:flex-col md:gap-8 md:justify-center md:text-start">
                    <h3 className="text-xl font-bold">Start Selling Your Art Within Minutes For FREE!</h3>
                    <span className="block max-w-96 text-sm text-gray-600 dark:text-gray-300 leading-5 tracking-wider">Join our online art marketplace and unleash your creativity to a global audience for FREE! Showcase your art with crafttatva.com, connect with lovers worldwide, and effortlessly manage your sales-all without any fees or restrictions. Elevate your artistic journey with us today!</span>
                    <ul className='flex flex-col gap-4 text-sm text-gray-600 dark:text-gray-300 tracking-wider'>
                        {description.map((d: string, index: number) => (
                            <li key={index} className='flex items-center'>
                                <div className='w-3 h-3 origin-center rotate-45 bg-gray-200' />
                                <span className='ms-3 flex-1'>{d}</span>
                            </li>
                        ))}
                    </ul>
                </div>
                <div className='hidden md:block md:w-px bg-gray-200 mx-6 md:mx-10' />
                <div className='flex-1 w-full'>
                    <Outlet />
                </div>
            </div>
        </center>
    );
}